import { useHydrateAtoms } from 'jotai/utils';

export const HydrateAtoms = ({ initialValues, children }: any) => {
  useHydrateAtoms(initialValues);
  return children;
};
